export const numberChildMultiplier = {
  1 : 1,
  2 : 1.6,
  3 : 2,
  4 : 2.3,
  5 : 2.5,
  6 : 2.625,
  7 : 2.75,
  8 : 2.813,
  9 : 2.844,
  10 : 2.86
}

export const allotAmountRanges = {
  RANGE1_MIN : 0.00,
  RANGE1_MAX : 800.00,
  RANGE2_MIN : 801.00,
  RANGE2_MAX : 6666.00,
  RANGE3_MIN : 6667.00,
  RANGE3_MAX : 10000.00,
  RANGE4_MIN : 10001.00,
  RANGE4_MAX : Number.MAX_VALUE, 
}



